var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamMailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-mail-6138298 1",
    clipPath: "url(#clip0_2354_10596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.508 -0.0947266H19.4925C20.8702 -0.0923736 21.9976 0.985038 21.9976 2.31657V13.6836C21.9976 15.0112 20.8716 16.0949 19.4925 16.0949H2.508C1.12884 16.0949 0.00292969 15.0112 0.00292969 13.6836V2.31657C0.00317413 0.986215 1.1264 -0.090256 2.508 -0.0947266ZM20.6988 2.2121L12.241 9.00457C11.5011 9.59892 10.4312 9.58527 9.72351 8.97539L1.30166 2.2121C1.29849 2.24645 1.29677 2.28127 1.29677 2.31657V13.6836C1.29677 14.3236 1.84335 14.8495 2.508 14.8495H19.4925C20.1571 14.8495 20.7037 14.3236 20.7037 13.6836V2.31657C20.7037 2.28127 20.702 2.24645 20.6988 2.2121ZM11.4173 8.05092L19.9168 1.22527L19.4927 1.15069L2.4464 1.15233L2.08413 1.22551L10.5862 8.05116C10.8282 8.24598 11.176 8.24457 11.4173 8.05092Z",
    fill: "black",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2354_10596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamMailIcon);
export default __webpack_public_path__ + "static/media/teamMailIcon.ecbcd72335109b444ec25a99f41fde4a.svg";
export { ForwardRef as ReactComponent };